module.exports = __webpack_public_path__ + "static/media/arrow-from-right.c377ae4a.svg";